var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-card',{staticClass:"text-center",staticStyle:{"margin-bottom":"10px"},attrs:{"bg-variant":"dark","header":_vm.task.title,"text-variant":"white"}},[_c('b-card-body',[_c('b-button',{staticClass:"add-crew-btn",attrs:{"size":"sm"},on:{"click":function($event){}}},[_vm._v("I'll do it ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }